import PerformanceMetric from './PerformanceMetric';
import './performance-metric.scss';

export default PerformanceMetric;
